import React, { useEffect, useState } from "react";
import { csvSafeRows } from "../../utils/csvSafe";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { selectToken } from "../auth/auth.selector";
import { exportAllUsersDataByChoiceData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "./ReactVortoxSpinner";

const SelectExportables = ({
  name,
  exportableData,
  filters,
  callFunction,
  isLoadingCSV,
  csvData,
  setCsvData,
}) => {
  const dispatch = useDispatch();
  const { loading, usersExportedData } = useSelector((state) => state.api);
  const token = useSelector(selectToken);

  const [sendableQP, setSendableQP] = useState("");
  const [exportedData, setExportedData] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);

  const onChangeFormCheck = (field) => {
    const currentFields = sendableQP ? sendableQP.split(",") : [];

    if (field === "all") {
      if (currentFields.includes("all")) {
        setSendableQP("");
      } else {
        setSendableQP(exportableData.join(","));
      }
    } else {
      const isFieldChecked = currentFields.includes(field);

      if (isFieldChecked) {
        const updatedFields = currentFields.filter((item) => item !== field);

        const filteredFields = updatedFields.filter((item) => item !== "all");
        setSendableQP(filteredFields.join(","));
      } else {
        const updatedFields = [...currentFields, field];

        const finalFields =
          updatedFields.length === exportableData.length
            ? [...updatedFields, "all"]
            : updatedFields;

        setSendableQP(finalFields.join(","));
      }
    }
  };

  const onClickConfirmButton = () => {
    setIsConfirmed(true);
  };

  useEffect(() => {
    let sendableQPs = "";
    if (filters) {
      for (const key in filters) {
        if (key && filters[key]) {
          sendableQPs += `&${key}=${filters[key]}`;
        }
      }
    }

    if (isConfirmed) {
      if (name === "users") {
        dispatch(
          exportAllUsersDataByChoiceData({
            queryParameters: `${sendableQPs}&fields=${sendableQP}`,
            token: token,
          })
        );
      } else if (name === "members") {
        try {
          callFunction(filters, `&fields=${sendableQP}`);
        } catch (error) {
          console.log(error);
        }
      } else if (name === "pt-reports" || name === "sales-table") {
        const { page, limit, ...rest } = filters || {};
        try {
          callFunction({ ...rest, is_export: 1, fields: sendableQP });
        } catch (error) {
          console.log(error);
        }
      } else if (name === "leads") {
        const { page, limit, ...rest } = filters || {};
        try {
          callFunction({ ...rest, is_export: 1, columnNames: sendableQP });
        } catch (error) {
          console.log(error);
        }
      } else if (
        name === "raw-lead" ||
        name === "odm" ||
        name === "pt-flow-taee" ||
        name === "health_tracking" ||
        name === "gym_compliance" ||
        name === "subscriptions"
      ) {
        const { page, limit, ...rest } = filters || {};
        try {
          callFunction({ ...rest, is_export: 1, fields: sendableQP });
        } catch (error) {
          console.log(error);
        }
      }
      setIsConfirmed(false);
    }
  }, [isConfirmed, sendableQP]);

  useEffect(() => {
    if (usersExportedData) {
      setExportedData(usersExportedData);
      setSendableQP("");
    }
  }, [usersExportedData]);

  return (
    <div
      className={`wFull ${
        name !== "pt-flow-taee" ? "maxWidth50VW" : ""
      } exportablesContainer mt30`}
    >
      <div
        className="flexWrap"
        style={{ gap: "2rem", width: "100%", maxWidth: "100%" }}
      >
        {exportableData?.length > 0 ? (
          exportableData.map((field, index) => (
            <Form.Check
              type={"checkbox"}
              id={`default-${field}`}
              label={`${field?.replace(/_/g, " ")}`}
              key={index}
              checked={sendableQP.split(",").includes(field)}
              onChange={() => onChangeFormCheck(field)}
            />
          ))
        ) : (
          <span className="noDataFound mt30">No Fields Found</span>
        )}
      </div>

      <div className="flexEnd mt30">
        {loading || isLoadingCSV ? (
          <ReactVortoxSpinner />
        ) : (
          <>
            {exportedData || csvData ? (
              <CSVLink
                download={"users_data.csv"}
                className="btn-k red-bg-k decoration-none-k"
                data={csvSafeRows(
                  name === "members" ||
                  name === "pt-reports" ||
                  name === "sales-table" ||
                  name === "leads" ||
                  name === "raw-lead" ||
                  name === "odm" ||
                  name === "pt-flow-taee" ||
                  name === "health_tracking" ||
                  name === "gym_compliance" ||
                  name === "subscriptions"
                    ? csvData
                    : exportedData
                )}
                onClick={() => {
                  setIsConfirmed(false);
                  setExportedData("");
                  setSendableQP("");
                  setCsvData && setCsvData("");
                }}
              >
                Export CSV
              </CSVLink>
            ) : (
              <Button variant="outline-primary" onClick={onClickConfirmButton}>
                confirm
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectExportables;
